<div class="www-pro-edu-tra-faq">
  <p class="www-pro-edu-tra-faq__que" [ngClass]="{ active: isActive() }" (click)="isActive.set(!isActive())">
    {{ faq.question }}
    <svg xmlns="http://www.w3.org/2000/svg" width="7.014" height="10.517" viewBox="0 0 7.014 10.517" fill="#a0a0a0">
      <path
        id="Icon_ionic-ios-arrow-round-down"
        data-name="Icon ionic-ios-arrow-round-down"
        d="M18.127,14.582a.477.477,0,0,0-.672,0L15.231,16.8V8.346a.475.475,0,0,0-.95,0V16.8l-2.225-2.221a.481.481,0,0,0-.672,0,.473.473,0,0,0,0,.669l3.032,3.01h0a.533.533,0,0,0,.15.1.453.453,0,0,0,.183.037.476.476,0,0,0,.332-.135l3.032-3.01A.465.465,0,0,0,18.127,14.582Z"
        transform="translate(-11.247 -7.875)"
      />
    </svg>

    <!-- <img class="arrow" [ngClass]="{ active: isActive() }" src="assets/images/pages/account/pro-education/arrow.svg" /> -->
  </p>
  @if (isActive()) {
    <p class="www-pro-edu-tra-faq__ans" [appAnimate]="'fadeInUp'" [speed]="'fast'">
      {{ faq.answer }}
    </p>
  }
</div>
